/**
 * Query to fetch a single marketplace_seller with all details
 */
const sellerDetailsQuery = `
query MarketplaceSellerDetails($id: ID!) {
  marketplace_seller(id: $id) {
    objectId
    name
    phone
    slug
    email
    website
    address
    city
    zip
    enabled
    public
    b2b
    b2c
    public_prices
    ask_for_info
    plan
    logo {
      name
      url
    }
    home_cover {
      name
      url
    }
    org_pointer {
      objectId
      nome
      email
      tipo_istanza
      stato
    }
    categories {
      edges {
        node {
          objectId
          name
        }
      }
    }
    createdAt
    updatedAt
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellerDetailsQuery;
